import { Marketdate } from './';
import { User } from './user.model';
import { GeoEntity } from './geo-entity.model';
import { JsonProperty } from 'json-typescript-mapper';
import { Weather } from './weather.model';

export enum MarketStatus {
  Unopened = <any>'Unopened',
  Opened = <any>'Opened',
  Absent = <any>'Absent',
  Closed = <any>'Closed',
  Paused = <any>'Paused',
  Canceled = <any>'Canceled',
  Confirmed = <any>'Confirmed',
  CanceledWeather = <any>'CanceledWeather',
  CanceledOtherEvent = <any>'CanceledOtherEvent',
  Manual = <any>'Manual'
};

export class MarketdateStatus {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('marketdayNumber')
  public marketdayNumber?: string;

  @JsonProperty('updated')
  public updated?: any;

  @JsonProperty('created')
  public created?: any;

  @JsonProperty('status')
  public status?: MarketStatus;

  @JsonProperty({clazz: Marketdate, name: 'marketdate'})
  public marketdate?: Marketdate;

  @JsonProperty({clazz: User, name: 'updatedBy'})
  public updatedBy?: User;

  @JsonProperty({clazz: User, name: 'updatedByBranchmaster'})
  public updatedByBranchmaster?: User;

  @JsonProperty('comment')
  public comment?: string;

  @JsonProperty({clazz: GeoEntity, name: 'geoEntity'})
  public geoEntity?: GeoEntity;

  @JsonProperty({clazz: Weather, name: 'weather'})
  public weather?: Weather;

  constructor() {
    this.id = void 0;
    this.marketdayNumber = void 0;
    this.status = void 0;
    this.updated = void 0;
    this.created = void 0;
    this.marketdate = void 0;
    this.updatedBy = void 0;
    this.comment = void 0;
    this.geoEntity = void 0;
    this.weather = void 0;
    this.updatedByBranchmaster = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/marketdate-status.model.ts